module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/5-67f80b55bc1b2e4cb16b75cd8d1c6f56.svg";